import Vue from 'vue'
import Router from 'vue-router'
import login from '../views/login'
import home from '../views/home'
import bookShelf from '../views/bookShelf'
import bookManagement from '../views/materialManagement/bookManagement'
import contentManagement from '../views/materialManagement/contentManagement'
import authCodeManagement from '../views/secretKeyManagement/authCodeManagement'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      children: [
        {path: '/bookShelf', name: '书架', component: bookShelf},
        {path: '/bookManagement', name: '书籍管理', component: bookManagement},
        {path: '/contentManagement', name: '内容管理', component: contentManagement},
        {path: '/authCodeManagement', name: '激活码管理', component: authCodeManagement}
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js